"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AppLink = /** @class */ (function (_super) {
    __extends(AppLink, _super);
    function AppLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClick = function (e) {
            e.preventDefault();
            if (_this.props.onClick) {
                _this.props.onClick();
            }
            else {
                if (_this.props.open) {
                    _this.props.host.open(_this.props.request).then(function (openedHost) {
                        if (_this.props.onHostOpened) {
                            _this.props.onHostOpened(openedHost);
                        }
                    });
                }
                else {
                    _this.props.host.load(_this.props.request);
                }
            }
        };
        return _this;
    }
    AppLink.prototype.render = function () {
        var href = this.props.host.getUrl(this.props.request);
        var content = React.Children.count(this.props.children) > 0 ? this.props.children : this.props.title;
        return (React.createElement("a", { style: this.props.style, className: this.props.className, title: this.props.title, href: href, onClick: this._onClick }, content));
    };
    return AppLink;
}(React.Component));
exports.AppLink = AppLink;
